/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import * as Icons from "heroicons-react";
import { useEffect, useRef, useState } from "react";
import { Form, Table } from "react-bootstrap";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import "./Purchase.css";
// import useCarts from "../Hooks/useCarts";
import axios from "axios";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { Toaster } from "react-hot-toast";
import usePurchase from "../Hooks/usePurchase";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";

import DatePicker from "react-datepicker";
import { AiOutlineClose } from "react-icons/ai";
import { BsArchive, BsCheckSquare, BsSquare } from "react-icons/bs";
import { IoReload } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetGrn,
  selectCalculation,
  selectNote,
  selectPoNo,
  selectProducts,
  selectShipping,
  selectStatus,
  selectSupplier,
  selectTPNNo,
  selectUser,
  selectVoucherDate,
  selectVoucherNo,
  selectWareHouse,
} from "../../features/grnSlice";
import { useAddGrnMutation, useGrnsCountQuery } from "../../services/grnApi";
import {
  useAddPurchaseMutation,
  useUpdatePurchaseStatusMutation,
} from "../../services/purchasApi";
import SelectPriceGrn from "../Common/CustomSelect/ScelectPriceGrn";
import SelectGRNSupplier from "../Common/CustomSelect/SelectGRNSupplier";
import SelectPurchase from "../Common/CustomSelect/SelectPurchase";
import SelectTPN from "../Common/CustomSelect/SelectTPN";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import { apiUniqueErrHandle } from "../Utility/Utility";
// import PosCart from "../Pages/POS/Parts/PosCart";
// import useProducts from "../Hooks/useProducts";

const GRNCreate = () => {
  let i = 1;
  let j = 1;
  let navigate = useNavigate();
  const [poNo, setPoNo] = useState("");
  const [isFull, setIsFull] = useState(false);
  const [isPO, setIsPO] = useState(false);
  const [isTPN, setIsTPN] = useState(false);
  const [isNoPo, setIsNoPo] = useState(true);
  const tableRef = useRef(null);

  const [onShow, setOnShow] = useState(false);
  const [newPrice, setNewPrice] = useState(false);
  const [grnProducts, setGrnProducts] = useState([]);
  const [supplierProduct, setSupplierProduct] = useState([]);
  const statusRef = useRef();
  const firstProductRef = useRef(null);

  const supplierSearchRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [filteredProduct, setFilteredProduct] = useState(supplierProduct);

  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const { grnTotalItems, totalItems } = usePurchase();
  const lang = useSelector((state) => state.languageReducer);

  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

  const dispatch = useDispatch();
  const grnData = useSelector((state) => state.grnReducer);
  console.log("grnData", grnData);
  const handleClose = () => setOnShow(false);
  const user = signInUser();
  const { aamarId } = user;
  const handleOnEnter = (event) => {
    // console.log("event", event);
    if (event.keyCode === 40) {
      tableRef.current.focus(); // Check if the ref and focus() method are correct
    }
  };
  // console.log(grnData);
  const [addPurchase] = useAddPurchaseMutation();

  // RTK API CALL
  const [addGrn] = useAddGrnMutation();
  const [updatePurchase] = useUpdatePurchaseStatusMutation();
  const { data: countData } = useGrnsCountQuery({ aamarId });
  const [purchaseProduct, setPurchaseProduct] = useState({ products: [] });
  const [voucherDate, setVoucherDate] = useState(
    format(new Date(), "MM-dd-yyyy")
  );
  const [supplierValue, setSupplierValue] = useState();

  // const { updateInventoryIn, inventoryIn, inventory, setInventory } =
  //   useInventory();
  const { total_item, total, tax } = totalItems(purchaseProduct?.products);
  const {
    grntotal_item,
    grntotal,
    grntax,

    groundTotal,
  } = grnTotalItems(grnData.products);

  useEffect(() => {
    setFilteredProduct(supplierProduct);
  }, [supplierProduct]);

  useEffect(() => {
    if (isFull) {
      dispatch(selectStatus("Complete"));
    } else {
      dispatch(selectStatus("Complete"));
    }
  }, [isFull]);

  useEffect(() => {
    const newP = grnData?.products?.find((pro) => pro.newPrice === true);
    // console.log(grnData?.products);
    if (newP) {
      setNewPrice(true);
    } else {
      setNewPrice(false);
    }
  }, [grnData?.products]);

  // console.log(newPrice);

  useEffect(() => {
    grnData?.products?.length > 0 && setGrnProducts(grnData.products);
    dispatch(
      selectCalculation({
        totalItem: grntotal_item,
        total: grntotal,
        tax: grntax,
        groundTotal: groundTotal,
      })
    );
  }, [grntotal, grnData.products]);

  const handleSelectItem = (id) => {
    let newList = [];
    const productList = Array.isArray(purchaseProduct?.products)
      ? purchaseProduct.products
      : Array.isArray(purchaseProduct)
      ? purchaseProduct
      : [];
    const selected = productList.find(
      (p) => (p?.id || p?._id) === id || p?.article_code === id
    );
    if (grnData?.products?.length > 0) {
      const exist = grnData?.products?.find(
        (p) => (p?.id || p?._id) === id || p?.article_code === id
      );
      const rest = grnData?.products?.filter(
        (p) => (p?.id || p?._id) !== id && p?.article_code !== id
      );
      if (exist) {
        newList = [...grnData.products];
        dispatch(selectProducts(newList));
        notify("Products Already Selected", "error");
      } else {
        notify("Product is added", "success");
        newList = [
          ...rest,
          {
            id: selected?.id,
            article_code: selected?.article_code,
            priceId: selected?.priceId?._id,
            tp: selected?.priceId?.tp ? selected?.priceId?.tp : 0,
            newPrice: false,
            name: selected?.name,
            mrp: selected?.priceId?.mrp ? selected?.priceId?.mrp : 0,
            tax: selected?.tax || 0,
            qty: selected?.qty || 0,
            unit: selected?.unit,
            discount: 0,
            warehouse: user?.warehouse,
            aamarId: user?.aamarId,
            order: grnData.products.length + 1,
          },
        ];
      }

      // console.log(grnData.products, purchaseProduct.products);
      dispatch(selectProducts(newList));
      setIsFull(false);
    } else {
      newList = [
        {
          id: selected?.id,
          article_code: selected?.article_code,
          priceId: selected?.priceId?._id,
          tp: selected?.priceId?.tp ? selected?.priceId?.tp : 0,
          newPrice: false,
          name: selected?.name,
          mrp: selected?.priceId?.mrp ? selected?.priceId?.mrp : 0,
          tax: selected?.tax || 0,
          qty: selected?.qty || 0,
          unit: selected?.unit,
          discount: 0,
          warehouse: user?.warehouse,
          aamarId: user?.aamarId,
          order: grnData?.products?.length + 1,
        },
      ];
      dispatch(selectProducts(newList));
    }
  };

  // HANDLE CUSTOM QTY
  const handleCustomQty = (e, id) => {
    const customQty = e.target.value !== "" ? e.target.value : 0;

    const productList = Array.isArray(purchaseProduct?.products)
      ? purchaseProduct.products
      : Array.isArray(purchaseProduct)
      ? purchaseProduct
      : [];

    const selected = productList.find(
      (p) => (p?.id || p?._id) === id || p?.article_code === id
    );
    const item = grnData?.products?.find(
      (p) => (p?.id || p?._id) === id || p?.article_code === id
    );

    if (item) {
      if (Number(customQty) >= 0) {
        if (selected && selected?.qty !== undefined && selected?.qty !== null) {
          if (Number(selected.qty) >= Number(customQty)) {
            const newGrn = grnData?.products?.map((p) =>
              (p?.id || p?._id) === id ||
              (item?.article_code && p?.article_code === item?.article_code)
                ? { ...p, qty: customQty }
                : p
            );
            dispatch(selectProducts(newGrn));
            setIsFull(false);
          } else {
            notify(
              `Quantity cannot exceed ordered quantity (${selected.qty})`,
              "error"
            );
          }
        } else {
          const newGrn = grnData?.products?.map((p) =>
            (p?.id || p?._id) === id ||
            (item?.article_code && p?.article_code === item?.article_code)
              ? { ...p, qty: customQty }
              : p
          );
          dispatch(selectProducts(newGrn));
          setIsFull(false);
        }
      }
    }
  };
  // HANDLE CUSTOM TP
  const handleCustomTp = (e, id) => {
    const customTp = e.target.value !== "" ? e.target.value : 0;

    const item = grnData?.products?.find(
      (p) => (p?.id || p?._id) === id || p?.article_code === id
    );
    if (item) {
      if (Number(customTp) >= 0) {
        const newGrn = grnData?.products?.map((p) =>
          (p?.id || p?._id) === id ||
          (item?.article_code && p?.article_code === item?.article_code)
            ? { ...p, tp: customTp }
            : p
        );
        dispatch(selectProducts(newGrn));
        setIsFull(false);
      }
    }
  };

  // HANDLE CUSTOM MRP
  const handleCustomMrp = (e, id) => {
    const customMrp = e.target.value !== "" ? e.target.value : 0;

    const item = grnData?.products?.find(
      (p) => (p?.id || p?._id) === id || p?.article_code === id
    );
    if (item) {
      if (Number(customMrp) >= 0) {
        const newGrn = grnData?.products?.map((p) =>
          (p?.id || p?._id) === id ||
          (item?.article_code && p?.article_code === item?.article_code)
            ? { ...p, mrp: customMrp }
            : p
        );
        dispatch(selectProducts(newGrn));
        setIsFull(false);
      }
    }
  };

  const removeFromGrn = (id) => {
    const remain = grnData.products.filter((p) => p.id !== id);
    dispatch(selectProducts(remain));
    setIsFull(false);
  };
  const removeAllFromGrn = () => {
    dispatch(selectProducts([]));
    setIsFull(false);
  };

  const handleSelectAllProducts = (products) => {
    notify("All products added", "success");
    // console.log("select all");
    let seletedProducts = [];
    let i = 1;
    products.map((pro) => {
      seletedProducts = [
        ...seletedProducts,
        {
          id: pro.id,
          article_code: pro?.article_code,
          priceId: pro?.priceId?._id,
          tp: pro?.priceId?.tp,
          newPrice: false,
          name: pro?.name,
          mrp: pro?.priceId?.mrp,
          tax: pro?.tax,
          qty: pro?.qty,
          unit: pro?.unit,
          discount: 0,
          warehouse: user?.warehouse,
          aamarId: user?.aamarId,
          order: pro.order,
        },
      ];
    });
    // console.log(seletedProducts);
    dispatch(selectProducts([]));
    dispatch(selectProducts(seletedProducts));
    setIsFull(true);
  };
  const handleDeselectAllProducts = () => {
    notify("All products removed", "error");
    dispatch(selectProducts([]));
    setIsFull(false);
  };

  // ADD NEW PRICE
  const addNewPrice = async () => {
    // console.log(purchaseProduct?.shipping_cost)
    // dispatch(selectShipping(purchaseProduct?.shipping_cost))
    // setLoader(true)
    // try {
    //   // if (grnData.products.length > 0) {
    //   //   console.log(grnData.products);
    //   //   //     // setUpdatePrice(false);
    //   //   grnData.products.map(async (pro) => {
    //   //     setNewPrice(false);
    //   //     //CHECK FOR NEW PRICE
    //   //     if (pro.newPrice === true) {
    //   //       console.log("old", pro.priceId);
    //   //       // ADD NEW PRODUCT
    //   //       let price = {};
    //   //       if (pro.newPrice) {
    //   //         price = {
    //   //           article_code: pro.id,
    //   //           supplier: grnData.supplier,
    //   //           warehouse: grnData.warehouse,
    //   //           tp: pro.tp,
    //   //           mrp: pro.mrp,
    //   //           status: "active",
    //   //         };
    //   //         const result = await addPrice(price);
    //   //         console.log(result);
    //   //         // RESET priceId & newPrice
    //   //         if (result?.data?.status === "success") {
    //   //           console.log("new", result?.data?.id);
    //   //           dispatch(
    //   //             selectNewPrice({
    //   //               id: pro.id,
    //   //               priceId: result?.data?.id,
    //   //               newPrice: false,
    //   //             })
    //   //           );
    //   //           notify("New Price Add Successful!", "success");
    //   //           setNewPrice(true);
    //   //           // setUpdatePrice(true);
    //   //           return true;
    //   //         }
    //   //       }
    //   //     }
    //   //   });
    //   //   //     setUpdatePrice(true);
    //   // }
    // } catch (err) {
    //   console.log(err);
    // } finally {
    //   setLoader(false)
    //   setNewPrice(true);
    // }
  };

  const handleGrnSubmit = async () => {
    if (countData >= user?.package?.grnLimited) {
      // alert("Please select a package to register to this user account")
      setModalVisible(true);
      return;
    } else {
      // console.log(grnData);
      let newIn = [];
      if (grnData?.poNo !== null) {
        // console.log(poNo);
        // console.log(statusRef.current.value);
        const statusP = statusRef?.current?.value;
        const sp = { poNo: poNo, status: statusP };
        if (statusP === "Received") {
          dispatch(selectStatus("Complete"));
        }
        // console.log(grnData);

        if (grnData?.products.length > 0) {
          const result = await Swal.fire({
            title: "Are you sure?",
            text: "Wanna create GRN?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, create it!",
          });

          if (result.isConfirmed) {
            if (grnData.poNo === "") {
              notify("Please Select PO ", "error");
            } else {
              try {
                setLoader(true);
                const response = await addGrn({ ...grnData, aamarId });
                // console.log(response);
                if (response?.data?.status === "success") {
                  await updatePurchase(sp);

                  dispatch(resetGrn());
                } else {
                  apiUniqueErrHandle(response?.data);
                }
              } catch (err) {
                console.log(err);
              } finally {
                setPurchaseProduct([]);
                setLoader(false);
                notify(`GRN Creation successful!`, "success");
                // dispatch(resetGrn())
                navigate("/grn");
              }
            }
          }
        } else {
          notify("There must be products for GRN", "error");
        }
      }

      if (grnData.poNo === null) {
        const poData = {
          aamarId: aamarId,
          poNo: "",
          supplier: grnData.supplier ? grnData.supplier : "",
          warehouse: user?.warehouse,
          products: grnData.products ? grnData.products : [],
          type: "",
          note: "",
          doc: "",
          totalItem: grnData.totalItem ? grnData.totalItem : 0,
          total: grnData.total ? grnData.total : 0,
          discount: 0,
          tax: 0,
          shipping_cost: grnData.shipping_cost ? grnData.shipping_cost : 0,
          userId: grnData.userId ? grnData.userId : 0,
          status: "Received",
        };
        // console.log(poData);
        setLoader(true);
        try {
          const result = await Swal.fire({
            title: "Are you Sure?",
            text: "Create this GRN?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, create it!",
          });

          if (result.isConfirmed) {
            await addPurchase(poData)
              .then(async (res) => {
                // console.log(res);

                const newGrn = {
                  ...grnData,
                  aamarId,
                  poNo: res?.data?.purchase?._id,
                  poId: res?.data?.purchase?.poNo,
                  status: "Complete",
                };
                // console.log(grnData);
                // console.log(newGrn);
                // console.log(grnData);
                await addGrn(newGrn)
                  .then((res) => {
                    // console.log(res);
                    dispatch(resetGrn());
                  })
                  .catch((err) => {
                    console.error(err);
                  });

                // if (dispatch(selectPoNoNew(res?.data?.purchase?.poNo)) && dispatch(selectPoIdNew(res?.data?.purchase?._id)) && dispatch(selectStatus("Complete"))) {
                // }
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            notify("Can not create purchase", "error");
            return;
          }
        } catch (err) {
          console.error(err);
        } finally {
          setPurchaseProduct([]);
          setLoader(false);
          notify("GRN Creation update successful!", "success");
          // dispatch(resetGrn())
          navigate("/grn");
        }
      }
    }
  };

  const handleVendorChange = async (value) => {
    // console.log(value?.option);

    setPoNo(value?.option);

    if (value?.option) {
      // console.log(value?.option);
      await axios
        .get(`${BASE_URL}purchase/grn/${value?.option}`)
        .then((response) => {
          console.log("datawh", response.data);
          dispatch(selectShipping(response?.data?.shipping_cost));
          setPurchaseProduct(response?.data);
          dispatch(selectSupplier(response.data?.supplier?._id));
          dispatch(selectWareHouse(user?.warehouse));
          dispatch(
            selectPoNo({ id: response.data?._id, no: response.data?.poNo })
          );
          dispatch(selectUser(user?.id));
          // console.log(response.data);
          dispatch(selectProducts([]));
          setNewPrice(false);
        });
    }
  };

  const handleTPNChange = async (e) => {
    // console.log(e);
    await axios
      .get(`${BASE_URL}tpn/grn/${e?.option}`)
      .then((response) => {
        // console.log(response);
        dispatch(selectShipping(response?.data?.shipping_cost));
        setPurchaseProduct(response.data);
        // dispatch(selectSupplier(response.data.supplier._id));
        dispatch(selectWareHouse(response.data.warehouseTo?._id));
        dispatch(selectTPNNo({ id: response.data._id }));
        dispatch(selectUser(user?.id));
        // console.log(response.data);
        dispatch(selectProducts([]));
        setNewPrice(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSupplierChange = async (e) => {
    dispatch(resetGrn());
    setPurchaseProduct([]);
    console.log(e);
    const supplierP = await axios.get(
      `${BASE_URL}supplier/details/${aamarId}/${e.option}`
    );

    console.log("supplierP", supplierP.data);
    let supplierProducts = [];
    if (supplierP.data?.productDetails?.length > 0) {
      supplierP.data?.productDetails?.map((product, index) => {
        supplierProducts = [
          ...supplierProducts,
          {
            id: product.id,
            article_code: product.article_code,
            tp: product?.price?.tp !== undefined ? product.price.tp : product?.tp || 0,
            mrp: product?.price?.mrp !== undefined ? product.price.mrp : product?.mrp || 0,
            name: product.name,
            aamarId: aamarId,
            warehouse: user?.warehouse,
            category: product.category?.name,
            stock: product.stock,
            tax: 0,
            qty: 0,
            discount: 0,
            order: index + 1,
          },
        ];
      });
    }
    // console.log(supplierProducts);
    setSupplierProduct(supplierProducts);
    dispatch(selectSupplier(e.option));
    dispatch(selectUser(user.id));
  };

  const handleOnChangePrice = async (id, e) => {
    let newCart = [];
    try {
      let price = await axios.get(`${BASE_URL}price/${e.option}`);
      // console.log(price);
      let selected = grnData.products.find((item) => item.id === id);
      let rest = grnData.products.filter((item) => item.id !== id);
      if (price.data) {
        newCart = [
          ...rest,
          {
            ...selected,
            mrp: price.data?.mrp,
            tp: price.data?.tp,
            priceId: price.data?._id,
          },
        ];
      }
    } catch (err) {
      notify(err, "error");
    } finally {
      // dispatch(selectProducts(newCart));
      dispatch(selectProducts(newCart));
    }
  };

  const handleNewPrice = (id) => {
    let pro = grnData.products;
    const select = pro.find((p) => p.id === id);
    const rest = pro.filter((p) => p.id !== id);
    // console.log(pro, state);
    let newProduct = [...rest, { ...select, newPrice: !select.newPrice }];
    // console.log(rest, select, id);
    dispatch(selectProducts(newProduct));

    // return { ...state, products:  };
  };

  const handleIsPO = () => {
    setIsPO(true);
    setIsTPN(false);
    setIsNoPo(false);
    dispatch(resetGrn());
    setSupplierProduct([]);
  };
  const handleDeSelectIsPO = () => {
    setIsPO(false);
    setIsTPN(true);
    setIsNoPo(false);
    dispatch(resetGrn());
  };
  const handleIsTPN = () => {
    setIsPO(false);
    setIsTPN(true);
    setIsNoPo(false);
    dispatch(resetGrn());
    setSupplierProduct([]);
  };
  const handleDeselectIsTPN = () => {
    setIsPO(true);
    setIsTPN(false);
    setIsNoPo(false);
    dispatch(resetGrn());
  };
  const handleDeselectIsNoPo = () => {
    setIsPO(true);
    setIsTPN(false);
    setIsNoPo(false);
    setPurchaseProduct([]);
  };
  const handleIsNoPO = () => {
    setIsPO(false);
    setIsTPN(false);
    setIsNoPo(true);
  };

  const refetchSupplierProduct = async () => {
    if (!grnData?.supplier) return;
    const supplierP = await axios.get(
      `${BASE_URL}supplier/details/${aamarId}/${grnData.supplier}`
    );

    console.log("supplierP", supplierP.data);

    let supplierProducts = [];
    if (supplierP.data?.productDetails?.length > 0) {
      supplierP.data?.productDetails?.map((product, index) => {
        supplierProducts = [
          ...supplierProducts,
          {
            id: product.id,
            article_code: product.article_code,
            tp: product?.price?.tp !== undefined ? product.price.tp : product.tp || 0,
            mrp: product?.price?.mrp !== undefined ? product.price.mrp : product.mrp || 0,
            aamarId: aamarId,
            warehouse: user?.warehouse,
            name: product.name,
            group: product.group,
            stock: product.stock,
            tax: 0,
            qty: 0,
            discount: 0,
            order: index + 1,
          },
        ];
      });
    }
    // console.log(supplierProducts);
    setSupplierProduct(supplierProducts);
  };
  const handleSearch = (q) => {
    console.log(q);
    console.log(supplierProduct);
    setSelectedIndex(0);
    if (q.length > 0) {
      const re = new RegExp(q, "i");
      const filtered = supplierProduct.filter((entry) =>
        Object.values(entry).some(
          (val) => typeof val === "string" && val.match(re)
        )
      );

      if (filtered.length > 0) {
        setFilteredProduct(filtered);
      } else {
        setFilteredProduct([]);
      }
      // console.log("Original:", supplierProduct);
      // console.log("filter:", filtered);
    } else {
      setFilteredProduct(supplierProduct);
    }
  };
  console.log("filteredProduct", filteredProduct);
  const handleKeyPress = (event) => {
    if (event.key === "ArrowUp") {
      setSelectedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
    } else if (event.key === "ArrowDown") {
      setSelectedIndex((prevIndex) =>
        prevIndex < filteredProduct.length - 1 ? prevIndex + 1 : prevIndex
      );
    }
  };

  const handleAddKeyPress = (e, item) => {
    const selectedRowItem = filteredProduct[selectedIndex];

    // console.log("Selected item:", selectedRowItem);
    handleSupplierSelectItem(selectedRowItem);
    // if (e.keyCode === 13) {
    // }
  };
  const handleSupplierSelectItem = async (item) => {
    // console.log(item.id);

    let newList = [];
    const result = await axios.get(`${BASE_URL}product/${item.id}`);
    // console.log("result", result);
    if (grnData.products.length > 0) {
      const exist = grnData?.products.find((p) => p.id === item.id);
      const rest = grnData?.products.filter((p) => p.id !== item.id);
      if (exist) {
        newList = [...grnData.products];
        dispatch(selectProducts(newList));
        notify("Products Already Selected", "error");
      } else {
        notify("Product is added", "success");

        newList = [
          ...rest,
          {
            id: item?.id,
            article_code: item?.article_code,
            aamarId: aamarId,
            warehouse: user?.warehouse,
            // priceId: item?.priceId?._id,
            tp: item?.tp ? item?.tp : 0,
            mrp: item?.mrp ? item?.mrp : 0,
            newPrice: false,
            name: item.name,
            group: item.group,
            // mrp: result?.data?.mrp ? result?.data?.mrp : 0,
            tax: item.tax,
            qty: item.qty,

            // unit: item.unit,
            discount: 0,
            order: grnData.products.length + 1,
          },
        ];
      }

      // console.log(grnData.products, purchaseProduct.products);
      dispatch(selectProducts(newList));
      setIsFull(false);
    } else {
      newList = [
        {
          id: item?.id,
          article_code: item?.article_code,
          // // priceId: item?.priceId?._id,
          tp: item?.tp ? item?.tp : 0,
          newPrice: false,
          name: item?.name,
          // group: item.group,
          aamarId: aamarId,
          warehouse: user?.warehouse,
          mrp: item?.mrp ? item?.mrp : 0,
          // mrp: result?.data?.mrp ? result?.data?.mrp : 0,
          tax: item?.tax,
          qty: item?.qty,
          // unit: item?.unit,
          discount: 0,
          order: grnData?.products?.length + 1,
        },
      ];
      dispatch(selectProducts(newList));
    }
  };
  return (
    <div>
      <div className="container-fluid ">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.goodsReceiveNote}></Header>
            <div className="row">
              {/* PURCHASE PRODUCT */}
              <div className="col-md-5">
                <div className="row">
                  <div className="col-12">
                    <Form.Label className="mt-3 w-full">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-center align-items-center">
                          <b>Purchase Order No </b>
                          {isPO ? (
                            <BsCheckSquare
                              onClick={() => handleDeSelectIsPO()}
                            />
                          ) : (
                            <BsSquare onClick={() => handleIsPO()} />
                          )}
                        </div>
                        <div className="d-flex justify-content-center align-items-center ms-3">
                          <b>TPN No </b>
                          {isTPN ? (
                            <BsCheckSquare
                              onClick={() => handleDeselectIsTPN()}
                            />
                          ) : (
                            <BsSquare onClick={() => handleIsTPN()} />
                          )}
                        </div>
                        <div className="d-flex justify-content-center align-items-center ms-3">
                          <b> Without Po </b>
                          {isNoPo ? (
                            <BsCheckSquare
                              onClick={() => handleDeselectIsNoPo()}
                            />
                          ) : (
                            <BsSquare onClick={() => handleIsNoPO()} />
                          )}
                        </div>
                      </div>
                    </Form.Label>
                    {isPO ? (
                      <SelectPurchase
                        handleVendorChange={handleVendorChange}
                      ></SelectPurchase>
                    ) : (
                      <></>
                    )}
                    {isTPN ? (
                      <SelectTPN
                        handleVendorChange={handleTPNChange}
                      ></SelectTPN>
                    ) : (
                      <></>
                    )}
                    {isNoPo ? (
                      <SelectGRNSupplier
                        handleOnchange={handleSupplierChange}
                      ></SelectGRNSupplier>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <Form.Label> PO Status</Form.Label>

                      <select
                        ref={statusRef}
                        className="form-select"
                        id="status"
                      >
                        <option value="Partial" disabled>
                          Partial GRN
                        </option>
                        <option selected value="Received">
                          Full GRN
                        </option>
                      </select>
                    </Form.Group>
                  </div>
                  <div className="col-12 py-2">
                    {purchaseProduct?.supplier?._id ? (
                      <div className="row">
                        <div className="col-6">
                          <p>
                            {/* {console.log(purchaseProduct?.supplier)} */}
                            <b>Vendor:</b> {purchaseProduct?.supplier?.company}
                            <br />
                            <b>Phone:</b> {purchaseProduct?.supplier?.phone}
                          </p>
                        </div>
                        <div className="col-6">
                          <p>
                            <b>PO:</b> {purchaseProduct?.poNo} <br />
                            <b>Date:</b>{" "}
                            {format(
                              new Date(purchaseProduct?.createdAt),
                              "MM/dd/yyyy"
                            )}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  {isNoPo === false ? (
                    <div className="col-12 ">
                      <div className="p-2 card">
                        <div
                          style={{
                            overflowY: "scroll",
                            display: "block",
                            maxHeight: "220px",
                          }}
                        >
                          <Table>
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Code</th>
                                <th>Name</th>
                                <th>Qty</th>
                                <th>TP</th>
                                {/* <th>Tax</th> */}
                                <th>Total</th>
                                <td>
                                  {isFull ? (
                                    <BsCheckSquare
                                      onClick={() =>
                                        handleDeselectAllProducts(
                                          purchaseProduct?.products || []
                                        )
                                      }
                                    />
                                  ) : (
                                    <BsSquare
                                      onClick={() =>
                                        handleSelectAllProducts(
                                          purchaseProduct?.products || []
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {purchaseProduct?.products?.length > 0 ? (
                                purchaseProduct?.products
                                  ?.slice()
                                  .sort((a, b) => a.order - b.order)
                                  .map((item) => (
                                    <tr key={item.article_code}>
                                      <th>{i++}</th>
                                      <td>{item.article_code}</td>
                                      <td>{item.name}</td>
                                      <td>{item.qty}</td>
                                      <td>
                                        {parseFloat(
                                          item?.tp ? item?.tp : 0
                                        ).toFixed(2)}
                                      </td>
                                      {/* <td>
                                {(
                                  parseFloat(item.qty) *
                                  (parseFloat(item.tp) *
                                    (parseFloat(item.tax) / 100))
                                ).toFixed(2)}
                              </td> */}
                                      <td>
                                        {item?.tp
                                          ? (
                                              parseFloat(item.qty) *
                                              (parseFloat(item.tp) +
                                                item.tp *
                                                  (parseFloat(item.tax) / 100))
                                            ).toFixed(2)
                                          : parseFloat(0).toFixed(2)}
                                        {/* {((parseFloat(item.tp) * (parseFloat(item.tax)) / 100)).toFixed(2)} */}
                                      </td>
                                      <td>
                                        {/* <BsSquareHalf className="me-2" /> */}
                                        <BsArchive
                                          onClick={() =>
                                            handleSelectItem(item.id)
                                          }
                                        />
                                      </td>
                                    </tr>
                                  ))
                              ) : (
                                <tr>
                                  <th colSpan={8} className="text-center">
                                    {" "}
                                    Please Select a GRN Order
                                  </th>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-12">
                      <div className="card">
                        <div className="card-header">
                          <div className="d-flex justify-content-between ">
                            <p>Supplier Products List</p>
                            <p
                              className="btn "
                              onClick={() => refetchSupplierProduct()}
                            >
                              {" "}
                              <IoReload />{" "}
                            </p>
                          </div>
                          <div className="">
                            <input
                              ref={supplierSearchRef}
                              className="form-control form-control-sm"
                              type="text"
                              placeholder="Search Product"
                              onChange={(e) => handleSearch(e.target.value)}
                              onKeyDown={(e) => {
                                handleOnEnter(e);
                              }}
                            />
                          </div>
                        </div>
                        <Table
                          ref={tableRef}
                          onKeyDown={(e) => {
                            handleKeyPress(e);
                          }}
                          onKeyPress={(e) => handleAddKeyPress(e)}
                          tabIndex="0"
                          className="mt-3 table-responsive "
                          // style={{
                          //   width: "100%",
                          //   overflowY: "scroll",
                          //   display: "block",
                          //   height: "350px",
                          // }}
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              {/* <th>Code</th> */}
                              <th>Name</th>
                              <th>Stock</th>
                              <th>TP</th>
                              {/* <th>Qty</th> */}
                              {/* <th>Tax</th> */}
                              {/* <th>Total</th> */}
                              <th>Add</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredProduct?.length > 0 ? (
                              filteredProduct
                                ?.slice()
                                .sort((a, b) => a.order - b.order)
                                .map((item, index) => (
                                  <tr
                                    key={item.article_code}
                                    // style={
                                    //   index == selectedIndex
                                    //     ? { backgroundColor: "yellow" }
                                    //     : null
                                    // }
                                    ref={index === 0 ? firstProductRef : null}
                                  >
                                    {/* {console.log(index, selectedIndex)} */}
                                    <th
                                      style={
                                        index === selectedIndex
                                          ? { backgroundColor: "yellow" }
                                          : null
                                      }
                                    >
                                      {i++}
                                    </th>
                                    {/* <td>{item.article_code}</td> */}
                                    <td
                                      title={item.article_code}
                                      style={
                                        index === selectedIndex
                                          ? { backgroundColor: "yellow" }
                                          : null
                                      }
                                    >
                                      {item.name} -{item.category}
                                    </td>
                                    <td
                                      style={
                                        index === selectedIndex
                                          ? { backgroundColor: "yellow" }
                                          : null
                                      }
                                    >
                                      {item.stock}
                                    </td>
                                    {/* <td>{item?.group ? item?.group : "No group"}</td> */}
                                    <td
                                      style={
                                        index === selectedIndex
                                          ? { backgroundColor: "yellow" }
                                          : null
                                      }
                                    >
                                      {parseFloat(
                                        item?.tp ? item?.tp : 0
                                      )?.toFixed(2)}
                                    </td>

                                    {/* <td>
                                      {item?.tp ? (
                                        parseFloat(item.qty) *
                                        (parseFloat(item.tp) +
                                          item.tp * (parseFloat(item.tax) / 100))
                                      ).toFixed(2) : parseFloat(0).toFixed(2)} */}
                                    {/* {((parseFloat(item.tp) * (parseFloat(item.tax)) / 100)).toFixed(2)} */}
                                    {/* </td> */}
                                    <td
                                      style={
                                        index === selectedIndex
                                          ? { backgroundColor: "yellow" }
                                          : null
                                      }
                                      // onKeyDown={handleKeyDownToSearch}
                                      // ref={index === 0 ? firstProductRef : null}
                                    >
                                      {/* <BsSquareHalf className="me-2" /> */}
                                      <BsArchive
                                        onClick={() =>
                                          handleSupplierSelectItem(item)
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}

                  <div className="col-12">
                    <Table className="bordered striped ">
                      <thead>
                        <tr>
                          <th>Items: {total_item}</th>
                          <th>
                            Tax: {parseFloat(tax > 0 ? tax : 0)?.toFixed(2)}
                          </th>
                          <th>Total: {total?.toFixed(2)}</th>
                          {/* <th>Order Discount: {purchase.discount}</th> */}
                          {/* <th>Shipping Cost: {purchase.shipping}</th> */}
                          <th>
                            Grand Total:{" "}
                            {(
                              parseFloat(total > 0 ? total : 0) +
                              parseFloat(tax > 0 ? tax : 0)
                            )?.toFixed(2)}
                          </th>
                        </tr>
                      </thead>
                    </Table>
                  </div>
                </div>

                {/* <Button
                  variant="dark"
                  className="float-end my-2"
                  type="submit"
                >
                  Submit
                </Button> */}
              </div>
              {/* GRN PRODUCT */}
              <div className="col-md-7 mb-3">
                <h5 className="pt-2">Receivable Products List</h5>
                <div
                  className="card px-1"
                  // style={{
                  //   overflowY: "auto",
                  //   display: "block",
                  //   maxHeight: "250px",
                  // }}
                >
                  <div className="table-responsive-sm ">
                    <Table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Code</th>
                          <th>Name</th>
                          <th>Qty</th>
                          <th>TP</th>
                          <th>MRP</th>
                          <th>CP</th>
                          <th>Total</th>
                          <td>
                            <AiOutlineClose onClick={removeAllFromGrn} />
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {grnData?.products?.length > 0 ? (
                          grnData?.products
                            ?.slice()
                            ?.sort((a, b) => a.order - b.order)
                            ?.map((item) => (
                              <tr key={item?.id}>
                                <th>{j++}</th>
                                <td>{item?.article_code}</td>
                                <td>{item?.name}</td>
                                <td className="col-2">
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control quantity"
                                      id={item?.id}
                                      onKeyPress={(e) => {
                                        if (
                                          e.key === " " ||
                                          (e.key === "." &&
                                            e.target.value.includes("."))
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const numericValue =
                                          e.target.value.replace(
                                            /[^0-9.]/g,
                                            ""
                                          );
                                        handleCustomQty(
                                          {
                                            ...e,
                                            target: {
                                              ...e.target,
                                              value: numericValue,
                                            },
                                          },
                                          item?.id
                                        );
                                      }}
                                      value={item?.qty}
                                    />
                                  </div>
                                </td>
                                <td className="col-2">
                                  <input
                                    type="text"
                                    disabled={!item?.newPrice}
                                    className="form-control quantity"
                                    id={item?.id}
                                    onKeyPress={(e) => {
                                      if (
                                        e.key === " " ||
                                        (e.key === "." &&
                                          e.target.value.includes("."))
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      const numericValue =
                                        e.target.value.replace(/[^0-9.]/g, "");
                                      handleCustomTp(
                                        {
                                          ...e,
                                          target: {
                                            ...e.target,
                                            value: numericValue,
                                          },
                                        },
                                        item?.id
                                      );
                                    }}
                                    value={item?.tp > 0 ? item?.tp : 0}
                                  />
                                </td>
                                <td style={{ width: "120px" }}>
                                  {item?.newPrice ? (
                                    <input
                                      type="text"
                                      className="form-control quantity"
                                      id={item?.id}
                                      onKeyPress={(e) => {
                                        if (
                                          e.key === " " ||
                                          (e.key === "." &&
                                            e.target.value.includes("."))
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onChange={(e) => {
                                        const numericValue =
                                          e.target.value.replace(
                                            /[^0-9.]/g,
                                            ""
                                          );
                                        handleCustomMrp(
                                          {
                                            ...e,
                                            target: {
                                              ...e.target,
                                              value: numericValue,
                                            },
                                          },
                                          item?.id
                                        );
                                      }}
                                      value={item?.mrp > 0 ? item?.mrp : 0}
                                    />
                                  ) : (
                                    <SelectPriceGrn
                                      sc={item?.id}
                                      setVal={item?.mrp || 0} // Ensure it defaults to 0 if item.mrp is falsy
                                      handleOnChangeCategory={
                                        handleOnChangePrice
                                      }
                                    />
                                  )}
                                </td>

                                <td>
                                  <Form.Check
                                    type="switch"
                                    checked={item?.newPrice}
                                    id="custom-switch"
                                    onChange={() => handleNewPrice(item?.id)}
                                    label=""
                                  />
                                </td>
                                <td>
                                  {(
                                    parseFloat(item?.qty || 0) *
                                    (parseFloat(item?.tp || 0) +
                                      parseFloat(item?.tp || 0) *
                                        (item?.tax
                                          ? parseFloat(item?.tax || 0) / 100
                                          : 0))
                                  ).toFixed(2)}
                                </td>

                                <td>
                                  <AiOutlineClose
                                    onClick={() => removeFromGrn(item.id)}
                                  />
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <th colSpan={8} className="text-center">
                              Please Select a GRN Order
                            </th>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>

                <Form.Group
                  className="mb-3 mt-2"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Shipping Cost</Form.Label>
                  <Form.Control
                    as="input"
                    type="number"
                    rows={3}
                    onChange={(e) => dispatch(selectShipping(e.target.value))}
                    // onChange={(e) => handleShippingData(e.target.value)}
                    // onChange={handleShippingData}
                  />
                </Form.Group>
                <Table className="bordered striped ">
                  <thead>
                    <tr>
                      <th>Items: {grntotal_item}</th>
                      <th>
                        Tax: {parseFloat(grntax > 0 ? grntax : 0)?.toFixed(2)}
                      </th>
                      <th>Total: {grntotal?.toFixed(2)}</th>
                      {/* {console.log(purchaseProduct)} */}
                      {/* <th>Order Discount: {purchase.discount}</th> */}
                      {/* <th>Shipping Cost: {purchase.shipping}</th> */}
                      <th>Shipping Cost: {grnData?.shipping_cost}</th>
                      {/* {console.log(typeof grnData?.shipping_cost)}
                      {console.log(grntotal + grntax + grnData?.shipping_cost)} */}
                      <th>
                        Grand Total:{" "}
                        {parseFloat(
                          parseFloat(grntotal > 0 ? grntotal : 0) +
                            parseFloat(grntax > 0 ? grntax : 0) +
                            parseFloat(grnData?.shipping_cost)
                        ).toFixed(2)}
                      </th>
                    </tr>
                  </thead>
                </Table>
                <div className="row">
                  <div className="col-8">
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Label>Voucher No</Form.Label>
                      <Form.Control
                        as="input"
                        rows={3}
                        required
                        onChange={(e) =>
                          dispatch(selectVoucherNo(e.target.value))
                        }
                      />
                    </Form.Group>
                  </div>
                  <div className="col-4">
                    <Form.Group className="" controlId="warehouse">
                      <Form.Label>Voucher Date</Form.Label>
                      <DatePicker
                        selected={new Date(voucherDate)}
                        className="form-control"
                        onChange={(date) => {
                          setVoucherDate(format(new Date(date), "MM-dd-yyyy"));
                          dispatch(
                            selectVoucherDate(
                              format(new Date(date), "MM-dd-yyyy")
                            )
                          );
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>GRN Note</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    required
                    onChange={(e) => dispatch(selectNote(e.target.value))}
                  />
                </Form.Group>
                {/* <button
                  // disabled={newPrice === true && "disabled"}
                  className="btn btn-dark me-3"
                // onClick={() => {
                 addNewPrice();
                // }}
                >
                  <Icons.CurrencyBangladeshiOutline size={20} /> Create New
                  Price
                </button> */}
                <button
                  // disabled={newPrice === false && "disabled"}
                  className="btn btn-dark"
                  onClick={() => {
                    handleGrnSubmit();
                  }}
                >
                  <Icons.SaveOutline size={20} /> Create GRN
                </button>
              </div>
            </div>
            <LoadingModal
              title="Please Wait..."
              onShow={onShow}
              handleClose={handleClose}
            />
            <Toaster position="bottom-right" />
            {/* Package Info Modal */}
            <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GRNCreate;
